const einProgram = {
  einProgram: {
    pageHeader: 'リードとEnphase Installer Network',
    title: 'EINメンバーシップが受理されました',
    overview: '概要',
    noCompany: '会社が見つかりません',
    goToDashboard: 'ダッシュボードに移動',
    messageFromCeo: 'CEOからのメッセージを読む',
    companyProfileLink: '会社概要を更新する',
    serviceAreasLink: 'サービスエリアの選択',
    leadsPreferencesLink: 'リードの設定を行う',
    reviewInstallerLink: '設置業者T&Cのレビュー',
    open: 'オープン',
    video: 'ビデオ',
    selected: '選択済み',
    learnMore: '詳細',
    completed: '完了',
    pending: '保留中',
    optInDisabledHeader: 'EINプログラム（近日公開）',
    optInDisabledDescription:
      'Enphase Installer Network (EIN)は、住宅所有者が貴社を見つける素晴らしい方法です!住宅所有者は、Enphase製品を使用して最高水準のカスタマーサービスとシステム品質を提供する設置業者を特定するために、EINを信頼しています。EINの会員になると、販売数、設置数、収益の増加につながるさまざまな特典を利用できます。',
    einTier: '貴社のEnphase Installer Network (EIN)のティア：',
    none: 'なし',
    viewBenefits: 'EINの特典をご覧になるには、クリックしてください ',
    here: 'ここ',
    anyQuestions: ' EINメンバーシップに関するご質問は、以下の連絡先までお問い合わせください。',
    enphaseAccountRepresentative: ' Enphase Account担当者。',
    learnReceivingLeads: 'Enphaseデジタルプラットフォームからどのようにリードを受け取るかをご覧ください。 ',
    benefitsOfEIN: 'EINのメリットを見る ',
    contactEnphaseRepresentative:
      '.EINおよびEnphase Leads Programについての詳細は、Enphase Account担当者にお問い合わせください。',
    congratulations: 'おめでとうございます!',
    whichInstaller: '%{tierName} 設置業者。',
    invitationText1: 'Enphase Installer Network (EIN)に招待されました。 ',
    invitationText2:
      'Enphase Installer Network (EIN)は、Enphase製品を使用し、卓越した住宅オーナーエクスペリエンスを提供する設置業者の信頼できるネットワークです。EINは、お客様との関係を強化し、お客様の成長を加速させることを目的としています。EINの会員になると、販売数、設置数、収益の増加につながるさまざまな特典を利用できます。すべての特典をご確認ください。 ',
    acceptInvitation: '招待を受け入れるには：',
    acceptTerms: '利用規約に同意します',
    cellmodemCheck: '同意します',
    cellmodemTeamcondition: ' 利用規約 ',
    cellmodemLinkTitle: 'Mobile Connectデータエクステンションの',
    notEstablished: '確立されていません。',
    contactEin: 'EINの詳細については、Enphase Account担当者にお問い合わせください。.',
    getFreeLeads: '無料リードを入手するには、以下のステップを完了してください：'
  }
};

export default einProgram;
